module.exports = __webpack_public_path__ + "img/y- (19).588ae67e.png";